export const GET_PURCHASEORDER_REQUEST = "GET_PURCHASEORDER_REQUEST";
export const GET_PURCHASEORDER_SUCCESS = "GET_PURCHASEORDER_SUCCESS";
export const GET_PURCHASEORDER_FAIL = "GET_PURCHASEORDER_FAIL";

export const CREATE_PURCHASEORDER_REQUEST = "CREATE_PURCHASEORDER_REQUEST";
export const CREATE_PURCHASEORDER_SUCCESS = "CREATE_PURCHASEORDER_SUCCESS";
export const CREATE_PURCHASEORDER_FAIL = "CREATE_PURCHASEORDER_FAIL";

export const UPDATE_PURCHASEORDER_REQUEST = "UPDATE_PURCHASEORDER_REQUEST";
export const UPDATE_PURCHASEORDER_SUCCESS = "UPDATE_PURCHASEORDER_SUCCESS";
export const UPDATE_PURCHASEORDER_FAIL = "UPDATE_PURCHASEORDER_FAIL";

export const DELETE_PURCHASEORDER_REQUEST = "DELETE_PURCHASEORDER_REQUEST";
export const DELETE_PURCHASEORDER_SUCCESS = "DELETE_PURCHASEORDER_SUCCESS";
export const DELETE_PURCHASEORDER_FAIL = "DELETE_PURCHASEORDER_FAIL";